import './App.css';
import LoginForm from './pages/Signup/Login/Login';
import AdminDashboard from './pages/admin/admin';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import Landingpage from './pages/Landingpage/Landingpage';
import InternshipRequestForm from './components/InternshipRequestForm/InternshipRequestForm';
import ManageRequest from './pages/ManageRequest/ManageRequest';
import AddCompany from './components/AddCompany/AddCompany';
import Statistics from './pages/Statistics/Statistics';
import PaymentSuccess from './components/PaymentFlow/PaymentSuccess';
function App() {
  return (
    <div className="App">
<BrowserRouter>
      <Routes>
        <Route path="/auth/home" />
        <Route path="/admin/auth/Listreservation"  />
        <Route path="/admin/auth/manageTable" />
        <Route path="/request-for-letter" element={<InternshipRequestForm/>} />
        <Route path="/admin/loginX" element={<LoginForm/>} />
        <Route path="/admin/add-comapany" element={<AddCompany/>} />
        <Route path="/admin/intern/request" element={<ManageRequest/>} />
        <Route path="/admin/intern/statistics" element={<Statistics/>} />
        <Route path="/" element={<Landingpage/>} />
        <Route path="/admin/auth/AdminDashboard" element={<AdminDashboard/>} />
        
        {/* Payment Routes */}
        <Route path="/internship/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment/callback" element={<Navigate to="/internship/payment-success" replace />} />
      </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
